module.exports = __webpack_public_path__ + "img/ce09e21.jpg";